import { FC, useContext } from 'react';

import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import { KeycloakContext } from 'components/Secured';

import useUnseenAiRuns from '../hooks/useUnseenAiRuns';

/**
 * The icon of the bulk import menu item, with how many AI imports of this browser are not seen yet (a
 * superuser's, as on the dashboard; a producer's one) and a turning ring while one runs.
 */
const AiRunsMenuBadge: FC = ({ children }) => {
  const keycloakCtx = useContext(KeycloakContext) as { keycloak?: { token?: string } } | undefined;
  const { unseen, running } = useUnseenAiRuns(true, () => keycloakCtx?.keycloak?.token);

  return (
    <Box position="relative" display="inline-flex" alignItems="center" justifyContent="center">
      {running && (
        <CircularProgress
          size={32}
          thickness={2.5}
          aria-label="AI-analys pågår"
          style={{ position: 'absolute', top: -4, left: -4 }}
        />
      )}
      <Badge
        badgeContent={unseen.length}
        color="secondary"
        overlap="circle"
        title={unseen.length ? `${unseen.length} nya AI-analyser` : undefined}
      >
        {children}
      </Badge>
    </Box>
  );
};

export default AiRunsMenuBadge;
